import { createStyles, Popover, Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import { Shift } from './models/api';

interface ShiftProps {
    shifts: Shift[]
}

export default class ShiftsDataGridCell extends React.PureComponent<ShiftProps> { 
    render() {
        const { shifts } = this.props;

        switch (shifts.length) {
            case 0: return false;
            case 1: return <SingleShiftDataGridCellWithStyles shift={shifts[0]} />
            default: return <MultipleShiftsDataGridCellWithStyles shifts={shifts} />
        }
    }
}

const shiftTextStyles = ({ typography }: Theme) => createStyles({
    'person': {
        'margin-right': '0.5rem',
    },
    'time': {
        'font-weight': typography.fontWeightLight
    }
})

class SingleShiftDataGridCell extends React.PureComponent<{ shift: Shift } & WithStyles<typeof shiftTextStyles>> {
    render() {
        const { shift, classes } = this.props;
        return <><span className={classes.person}>{shift.person  || '(nobody)'}</span><span className={classes.time}>{shift.start.substring(0, 5)} - {shift.end.substring(0, 5)}</span></>
    }
}

const SingleShiftDataGridCellWithStyles = withStyles(shiftTextStyles)(SingleShiftDataGridCell);

const popoverStyles = ({ spacing, typography }: Theme) => createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: spacing(1),
    },
    shift: {
        display: 'flex',
        'justify-content': 'space-between',
    },
    'shift-text': {
        cursor: 'default',
        fontSize: 14,
    },
    'shift-count': { }
});

interface MultipleShiftsDataGridCellState { 
    anchor: HTMLElement | null;
}

class MultipleShiftsDataGridCell extends React.PureComponent<ShiftProps & WithStyles<typeof popoverStyles> & WithStyles<typeof shiftTextStyles>, MultipleShiftsDataGridCellState> {

    constructor(props: ShiftProps & WithStyles<typeof popoverStyles> & WithStyles<typeof shiftTextStyles>) {
        super(props);
        this.state = { 
            anchor: null 
        };
    }

    private readonly handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.setState({ anchor: event.currentTarget });
      };
    
    private readonly handlePopoverClose = () => {
        this.setState({ anchor: null });
    };

    render() {
        const { shifts, classes }  = this.props;
        const anchor = this.state.anchor;
        const open = Boolean(anchor);

        return <>
            <Typography
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={this.handlePopoverOpen}
                onMouseLeave={this.handlePopoverClose}
                className={classes['shift-text']}
            >{ shifts.length + " shifts" }</Typography>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                paper: classes.paper,
                }}
                open={open}
                anchorEl={anchor}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={this.handlePopoverClose}
                disableRestoreFocus
            >
                <Typography component='div'>{ shifts.map((shift: Shift) => {
                    return <div key={`${shift.person}_${shift.start}`} className={classes.shift}>
                        <span className={classes.person}>{shift.person  || '(nobody)'}</span><span className={classes.time}>{shift.start.substring(0, 5)} - {shift.end.substring(0, 5)}</span> 
                        </div>
                }) }</Typography>
            </Popover>
        </>
    }
}

const MultipleShiftsDataGridCellWithStyles = withStyles((theme: Theme) => ({
    ...shiftTextStyles(theme),
    ...popoverStyles(theme),
}))(MultipleShiftsDataGridCell);